<template>
  <nav id="top" class="navbar topnav">
    <div class="navbar-brand" style="display: flex; flex-wrap: wrap; padding: 5px; height: 80px; align-items: center; width: 100%; justify-content: space-between;">
      <div style="padding-left: 16px;">
        <p style="color: #222; font-size: larger; font-weight: 700;">{{getParamName()}}</p>
      </div>
      <router-link to="/">
        <img src="@/assets/lp/logo_blue.svg" href="/" alt="HRモンスター">
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'CreateNav',
  componentName: 'CreateNav',
  components: {
  },
  props: {
    height: {
      type: String,
      default: '0px'
    },
    ismenu: true
  },
  mounted () {
    console.debug('*** Start *** mounted')
    console.log('LANGUAGE: ' + window.navigator.language)
    // var lang = window.navigator.language
    // if (lang.indexOf('en') !== -1) {
    //   lang = 'en'
    // } else {
    //   lang = 'ja'
    // }
    setTimeout(() => {this.handleClick_changeLanguage('ja')}, 2000)
    console.debug('*** End *** mounted')
  },
  data () {
    return {
      menuActive: false,
      showModal: false
    }
  },
  methods: {
    getParamName () {
      return this.$route.query.name ? this.$route.query.name : ''
    },
    handleClick_changeLanguage (lang) {
      console.debug('*** Start *** handleClick_changeLanguage')
      console.debug('lang: ' + JSON.stringify(lang))
      this.$i18n.locale = lang
      console.debug('*** End *** handleClick_changeLanguage')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.signup {
  font-weight: 900;
}
.topnav{
  font-size: 16px;
  background: #FEFEFE;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.hover-item:hover {
  color: white;
  background: rgba(50, 50, 100, 0.7);
}
.hover-item {
  color: black;
  font-weight: 600;
  padding: 10px 20px;
}
.inquiry {
  padding-right: 30px;
  padding-left: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #1B2C61;
  color:white;
}
img{
  height: 36px;
  width: auto;
  padding-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/CreateUser/CreateNav.vue